import { type SugarEnrollment } from '@app/types'
import { Badge, type BadgeProps, type MantineColor } from '@mantine/core'
import { type FC, useMemo } from 'react'
import { useSugarContext } from '@app/providers'

export interface EnrollmentStatusBadgeProps extends Omit<BadgeProps, 'children'> {
  enrollment: SugarEnrollment
}

// Filled rather than light, matching the badges on the letters and provider-photo
// surfaces — see ScholarshipSubStatusBadge for the reasoning. All three badges on
// a roster row have to agree, or the row reads as two different design systems.
export const EnrollmentStatusBadge: FC<EnrollmentStatusBadgeProps> = ({ enrollment, ...props }) => {
  const { getOptionLabelByValue } = useSugarContext()

  return (
    <Badge
      color={useMemo<MantineColor>(() => {
        switch (enrollment.status) {
          case 'site_claim_pending':
          case 'pending':
            return 'orange'
          case 'inactive':
            return 'red'
          default:
            return 'green'
        }
      }, [enrollment.status])}
      variant='filled'
      {...props}
    >
      {getOptionLabelByValue('enrollmentStatus', enrollment.status)}
    </Badge>
  )
}
